import { FormUserInvitation } from '../types';
import { isValidInvitation } from '../utils/is-valid-invitation';

export function hasValidInvitation(invitations: FormUserInvitation[]): boolean {
  return invitations.some(invitation => isValidInvitation(invitation));
}
